<template lang="pug">
  img.icon(:src="getSVG(path)")
</template>
<script>
export default {
  name: 'Icon',
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  methods: {
    getSVG (path) {
      return require(`@/assets${path}`)
    }
  }
}
</script>
